exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-broadcast-count[data-v-bf7d9fcc],.customer-broadcast-count span[data-v-bf7d9fcc]:last-child{margin-left:5px}", ""]);

// exports
